__turbopack_context__.v({
  "card": "style-module-scss-module__XFXSga__card",
  "imageCover": "style-module-scss-module__XFXSga__imageCover",
  "logo": "style-module-scss-module__XFXSga__logo",
  "text": "style-module-scss-module__XFXSga__text",
  "title": "style-module-scss-module__XFXSga__title",
});
